"use client";

import classNames from "classnames";
import { SocialProof } from "../components/molecules/SocialProof";
import { SocialProofTooltip } from "../components/molecules/SocialProofTooltip";
import { useMemo } from "react";
export const FooterDrawerUI = ({
	isVisible,
	isMobile,
	isSliderVariant,
	area,
	placesCount,
	formattedPlacesCount,
	possessiveFormArea,
	setIsSliderOpen,
	setReasonForOpening,
	trackSliderShown,
	trackItemTapped,
	onDrawerButtonClick,
	DrawerButtonComponent,
	isTransparent = false,
}) => {
	const ctaText = useMemo(() => {
		if (isMobile && isSliderVariant) return "What is your gluten sensitivity?";
		if (area === "worldwide") return "FIND THE PERFECT GF SPOTS";
		return `${area}'S FULL LIST`;
	}, [isMobile, isSliderVariant, area]);

	return (
		<div
			id="gfe-footer-drawer"
			className={classNames({
				"h-fit md:h-fit": true,
				"md:bg-transparent": isTransparent,
				"md:bg-white": !isTransparent,
				"bottom-0": true,
				"fixed z-10 w-screen md:top-auto inset-x-0": true,
				"py-4 px-3 md:px-4 flex flex-col md:flex-row md:justify-between items-center": true,
				"rounded-t-2xl md:rounded-none": true,
				"md:border-t md:border-gray-200": !isTransparent,
				"transition-all duration-300": true,
				"animate-slide-down": isVisible,
				"animate-slide-up": !isVisible,
			})}>
			{!isMobile && <SocialProofTooltip />}
			{isMobile ? null : (
				<h2
					className={classNames({
						"text-[13px] md:text-xl font-semibold text-blue-900 mb-2 md:mb-0 md:w-full": true,
					})}>
					{!placesCount || placesCount < 100
						? `Discover all ${possessiveFormArea} gluten-free spots`
						: `Discover ${possessiveFormArea} ${formattedPlacesCount} gluten-free spots`}
				</h2>
			)}
			<div className="flex flex-col md:flex-row w-full h-full min-h-full 
			items-center justify-end md:justify-center mb-0 md:mb-16 md:gap-2">
				{!isMobile && (
					<div className="items-center my-2 md:flex">
						<SocialProof
							textVariant="bold"
							text="new GF spots found today"
							position="left"
							variant="dark"
						/>
					</div>
				)}
				<div
					id="drawer-footer-get-the-app-button"
					className="w-full md:max-w-72 px-2 md:px-0">
					{DrawerButtonComponent && (
						<DrawerButtonComponent
							area={area}
							isMobile={isMobile}
							isSliderVariant={isSliderVariant}
							setIsSliderOpen={setIsSliderOpen}
							trackSliderShown={trackSliderShown}
							setReasonForOpening={setReasonForOpening}
							trackItemTapped={trackItemTapped}
							onDrawerButtonClick={onDrawerButtonClick}
							ctaText={ctaText}
						/>
					)}
				</div>
			</div>
		</div>
	);
};
